import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-user-icon',
  template: `
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_17784_455)">
        <path
          d="M22.2266 17.5068C24.0532 18.7468 25.3332 20.4268 25.3332 22.6668V26.6668H30.6666V22.6668C30.6666 19.7602 25.9066 18.0402 22.2266 17.5068Z"
          fill="currentColor"
        />
        <path
          d="M19.9999 16.0002C22.9466 16.0002 25.3332 13.6135 25.3332 10.6668C25.3332 7.72016 22.9466 5.3335 19.9999 5.3335C19.3732 5.3335 18.7866 5.46683 18.2266 5.6535C19.3332 7.02683 19.9999 8.7735 19.9999 10.6668C19.9999 12.5602 19.3332 14.3068 18.2266 15.6802C18.7866 15.8668 19.3732 16.0002 19.9999 16.0002Z"
          fill="currentColor"
        />
        <path
          d="M12.0013 16.0002C14.948 16.0002 17.3346 13.6135 17.3346 10.6668C17.3346 7.72016 14.948 5.3335 12.0013 5.3335C9.05464 5.3335 6.66797 7.72016 6.66797 10.6668C6.66797 13.6135 9.05464 16.0002 12.0013 16.0002ZM12.0013 8.00016C13.468 8.00016 14.668 9.20016 14.668 10.6668C14.668 12.1335 13.468 13.3335 12.0013 13.3335C10.5346 13.3335 9.33464 12.1335 9.33464 10.6668C9.33464 9.20016 10.5346 8.00016 12.0013 8.00016Z"
          fill="currentColor"
        />
        <path
          d="M12.0007 17.3335C8.44065 17.3335 1.33398 19.1202 1.33398 22.6668V26.6668H22.6673V22.6668C22.6673 19.1202 15.5606 17.3335 12.0007 17.3335ZM20.0007 24.0002H4.00065V22.6802C4.26732 21.7202 8.40065 20.0002 12.0007 20.0002C15.6006 20.0002 19.734 21.7202 20.0007 22.6668V24.0002Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_17784_455">
          <rect width="32" height="32" fill="currentColor" />
        </clipPath>
      </defs>
    </svg>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UserIconComponent {}
